import React from 'react';
import SEO from '../components/SEO';
import styles from './LegalPages.module.css';

function Disclaimer() {
  return (
    <>
      <SEO
        title="Disclaimer"
        description="Disclaimer for Sapienta VC website and services."
        canonical="https://sapienta.vc/disclaimer"
      />
      <div className={styles.container}>
      <p className={styles.effectiveDate}>Effective Date: 07/11/2025</p>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>1. General Information</h2>
        <p className={styles.text}>
          The information provided on this website, including but not limited to text, graphics, and other materials (collectively referred to as "Content"), is for general informational purposes only. Sapienta is a holding company that oversees a portfolio of diverse ventures ("Subsidiaries"). Each Subsidiary may have its own terms, conditions, and services, and this Disclaimer applies to the content and services available through Sapienta and its ventures collectively.
        </p>
        <p className={styles.text}>
          By using this website or any services provided by Sapienta or its subsidiaries, you acknowledge and agree to the following disclaimers.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>2. No Professional Advice</h2>
        <p className={styles.text}>
          The Content on this website is not intended to be, and should not be construed as, professional advice of any kind, including but not limited to legal, financial, investment, medical, or business advice. Any decisions you make based on the information provided on this website are your sole responsibility. We recommend consulting with a qualified professional for specific advice related to your situation.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>3. Accuracy of Information</h2>
        <p className={styles.text}>
          While we strive to provide accurate and up-to-date information, Sapienta and its subsidiaries do not guarantee the accuracy, completeness, or reliability of any Content on the website. We make no warranties or representations regarding the accuracy or timeliness of the information provided. The Content is subject to change without notice, and we cannot be held responsible for any errors or omissions.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>4. No Liability for Loss or Damage</h2>
        <p className={styles.text}>
          To the fullest extent permitted by law, Sapienta, its subsidiaries, officers, employees, and agents shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of your use of this website or any of the services offered. This includes, but is not limited to, damages for loss of profits, goodwill, use, or data, regardless of whether such damages were foreseeable or caused by breach of contract, tort, negligence, or otherwise.
        </p>
        <p className={styles.text}>
          You acknowledge that your use of this website and its services is at your own risk, and Sapienta does not guarantee uninterrupted or error-free operation of the website. We are not responsible for any technical issues, including but not limited to system downtime, data loss, or interruptions in service.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>5. Third-Party Links and Websites</h2>
        <p className={styles.text}>
          This website may contain links to third-party websites or resources, including those related to the services provided by Sapienta's subsidiaries. These links are provided for convenience and informational purposes only. Sapienta does not endorse, control, or monitor the content of these third-party sites. We are not responsible for the availability, accuracy, or content of these external websites and do not assume any liability for any damages or loss caused by your use of third-party sites.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>6. Investment and Financial Risks</h2>
        <p className={styles.text}>
          If the website or any of Sapienta's subsidiaries provide investment-related information, opportunities, or services, please note that investing carries inherent risks. The value of investments can fluctuate, and you may lose part or all of your investment. Sapienta and its subsidiaries do not provide investment advice, and nothing on this website should be interpreted as such. We recommend that you seek advice from a licensed financial advisor before making any investment decisions.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>7. No Endorsement of External Content</h2>
        <p className={styles.text}>
          Any mention of third-party products, services, or companies on this website is for informational purposes only and does not constitute an endorsement, recommendation, or affiliation by Sapienta or its subsidiaries unless explicitly stated otherwise.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>8. Forward-Looking Statements</h2>
        <p className={styles.text}>
          Some content on this website may contain forward-looking statements regarding the future performance or plans of Sapienta or its subsidiaries. These statements are based on our current expectations and assumptions and are subject to risks and uncertainties that could cause actual results to differ materially from those expressed or implied. Sapienta undertakes no obligation to update or revise any forward-looking statements.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>9. No Warranty of Availability</h2>
        <p className={styles.text}>
          While we aim to keep the website accessible, Sapienta does not warrant that access to the website will be uninterrupted, secure, or error-free. We do not guarantee that the website will be free of viruses or other harmful components. You are responsible for ensuring that your device is secure and protected while using the website.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>10. Changes to the Disclaimer</h2>
        <p className={styles.text}>
          Sapienta reserves the right to update or modify this Disclaimer at any time. Any changes will be posted on this page, and the effective date will be updated accordingly. We encourage you to review this page periodically for any changes. Your continued use of the website after the changes have been posted will constitute your acceptance of the updated Disclaimer.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>11. Governing Law and Jurisdiction</h2>
        <p className={styles.text}>
          This Disclaimer is governed by the laws of the State of New York, without regard to conflict of law principles. Any legal action or proceeding related to this Disclaimer shall be brought in the appropriate courts of the State of New York.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>12. Contact Information</h2>
        <p className={styles.text}>
          If you have any questions or concerns about this Disclaimer, please contact us at:
        </p>
        <p className={styles.text}>
          Email: legal@sapienta.vc<br />
          Address: 3811 Ditmars Blvd<br />
          Astoria, NY 11105-1803, US
        </p>
      </div>
    </div>
    </>
  );
}

export default Disclaimer; 